import { Component, Input,  } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { ApplicantPqqSectionsComponent } from '../applicant-pqq-sections.component';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgToastService } from 'ng-angular-popup';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { Router } from '@angular/router';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
  standalone: true,
  imports: [
    MatExpansionModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatRadioModule,
  ],
  selector: 'app-initial-info',
  templateUrl: './initial-info.component.html',
  styleUrls: ['./initial-info.component.css'],
})
export class InitialInfoComponent {
  formGroup: FormGroup;
  expressionData: any;
  isUpdate = false;
  eoi_id: any;

  @Input() initialData:any;
  constructor(
    private fb: FormBuilder,
    private toast: NgToastService,
    private projectsService: ProjectsService,
    private router: Router,
    private ApplicantPqqSectionsComponent: ApplicantPqqSectionsComponent
  ) {}

  onSubmit(): void {
      this.ApplicantPqqSectionsComponent.nextStep();
  }
}
